import {
	Array,
	Boolean,
	Dictionary,
	Literal,
	Null,
	Number,
	Optional,
	Record,
	Static,
	String,
	Undefined,
} from 'runtypes';

export const IdoInstanceRunType = Record({
	Color: String,
	CountOfIdoCreatedInTheInstanceByTheAuthenticatedUser: Number,
	ID: String,
	IsTheInstanceWhereAuthenticatedUserCreatedTheLastIdo: Boolean,
	Name: String,
	columnDefinitionJSON: String,
	exportAllowed: Optional(Boolean),
});

export type IdoInstance = Static<typeof IdoInstanceRunType>;

export const IdoSharedQueriesForTheKanbanBoardRunType = Record({
	idoIdoListToolbarCalculationIsActive: Optional(Boolean.Or(String).Or(Null)),
	idoInstanceId: String.Or(Null),
	label: String.Or(Null),
	serializedIdoIdoListToolbarHiddenDetailsSearchString: String.Or(Null),
	value: String.Or(Null),
});

export type IdoSharedQueriesForTheKanbanBoard = Static<typeof IdoSharedQueriesForTheKanbanBoardRunType>;

export const IdoListSummaryEntryRunType = Record({
	average: Number.Or(Null),
	dataIndex: String,
	max: Number.Or(Null),
	min: Number.Or(Null),
	numericValueCount: Number,
	sum: Number.Or(Null),
});

export type IdoListSummaryEntry = Static<typeof IdoListSummaryEntryRunType>;

export const IdosInInstanceCountResultRunType = Record({
	instance: String,
	instanceColor: String,
	instanceId: Number,
	totalCount: Number,
});

export type IdosInInstanceCount = Static<typeof IdosInInstanceCountResultRunType>;

export const IdoInstanceSearchResultRunType = Record({
	instance: String,
	instanceColor: String,
	instanceId: Number,
	results: Array(Dictionary(String.Or(Number).Or(Null).Or(Boolean).Or(Record({})), String)),
	totalCount: Number,
});

export type IdoInstanceSearchResult = Static<typeof IdoInstanceSearchResultRunType>;

export const IdoListViewModelRunType = Record({
	results: Array(IdoInstanceSearchResultRunType),
});

export type IdoListViewModel = Static<typeof IdoListViewModelRunType>;

export const IdoColumnsForTheInstanceRunType = Record({
	align: Literal('center')
		.Or(Literal('left').Or(Literal('right')))
		.Or(Undefined),
	field: String,
	label: String,
	name: String,
	sortable: Boolean,
});

export type IdoColumnsForTheInstance = Static<typeof IdoColumnsForTheInstanceRunType>;

export * from './detailsSearch';

export interface IdoListTab {
	aggregateId?: string;
	id: string;
	instance?: IdoInstance;
	instanceColor?: string;
	instanceId?: string;
	isActive: boolean;
	label: string;
	searchTerm?: string;
	sharedQuery?: IdoSharedQueriesForTheKanbanBoard;
	type: 'instance' | 'record' | 'sharedQuery';
}

export const IdoListCompleteExportCsvRunType = Record({});
